/*@ngInject*/
export default ['$resource', 'BASE_URL', function ($resource, BASE_URL) {
        return $resource(BASE_URL + "/pricings/numbers/:resource", {}, {
            getNumbers: { method: "GET", params: { resource: "with-documents" } },
            getAvailableCountries: { method: "GET", isArray: true, params: { resource: "countries" } }
        });
    }];
//# sourceMappingURL=pricing.numbers.service.js.map